import moment from 'moment/moment';
import Passport, {
  DOCUMENT_TYPE,
} from '@mos-front-components/public/es/components/Passport';
import passportEditableFields from './passportEditableFields';
import { DATE_FORMAT } from '../../helpers/date';

const { FIELD_NAME } = Passport;

const passportDisabled = (params) => {
  if (params.documentType !== DOCUMENT_TYPE.PASSPORT_RF) {
    return false;
  }
  if (params[FIELD_NAME.number]) {
    return true;
  }
  if (params[FIELD_NAME.dateOfIssue]) {
    return true;
  }
  if (params[FIELD_NAME.byWhom]) {
    return true;
  }
  return false;
};

/* eslint-disable camelcase */
const passportSerializer = (response) => {
  const { passport_rf } = response.data;

  const documentType = DOCUMENT_TYPE.PASSPORT_RF;
  const byWhom = (passport_rf.issued_by || '').trim();
  const dateOfIssue = passport_rf.issued_on
    ? moment(passport_rf.issued_on, DATE_FORMAT).clone().format(DATE_FORMAT)
    : '';
  const number = (passport_rf.number || '').replace(/[^0-9]+/gi, '');

  const passport = {
    documentType,
    [FIELD_NAME.byWhom]: byWhom,
    [FIELD_NAME.dateOfIssue]: dateOfIssue,
    [FIELD_NAME.number]: number,
  };

  return {
    data: passport,
    documents: [passport],
    editableFields: passportEditableFields(passport),
    disabled: passportDisabled(passport),
  };
};
/* eslint-enable camelcase */

export default passportSerializer;
